// Handle functionality of accordion menu
class Tabs {
	constructor(element) {
	    // Find all necessary elements
	    this.element = element;
	    this.tabsWrapper = document.querySelector(`[data-tabs="wrapper"]`);
	    this.url = this.tabsWrapper.dataset.url;
	    this.tabsContent = document.querySelector(`[data-tabs="content"]`);
 
	    // Get menus
	    this.items = element.querySelectorAll(`[data-tabs="item"]`);
 
	    // Init functionalities if all elements has been found
	    if (this.items.length > 0) {
		   this.init();
	    }
	    else {
		   console.error("missing elements to properly init tabs")
	    }
	}
 
	init() {
 
	    // Add functionality to show submenu on click of item
	    this.items.forEach(item => {
		   item.addEventListener('click', (e) => {
			  e.preventDefault();
 
			  // on click show submenu 
			  this.showContent(item);
		   });
	    });
	}
 
	showContent(item) {
	    let is_active = item.dataset.active;
	    let id = item.dataset.id;
	    
	    let html = document.querySelector(`html`);
	    let lang = html.getAttribute('lang');
	   
		// add class hide to content
		this.tabsContent.classList.add('hide');
	    
		// find all active elemnets
		let activeElemnets = this.tabsWrapper.querySelectorAll(`[data-tabs="item"][data-active="true"]`);

		// remove class and attributes if found active elements
		if (activeElemnets.length > 0) {
			activeElemnets.forEach(activeElemnet => {
				activeElemnet.setAttribute("data-active", "false");
				activeElemnet.classList.remove("active");
			});
		}
 
	    if (is_active == 'true') {
		   item.classList.remove("active");
		   item.setAttribute("data-active", "false");
	    } else {
		   item.classList.add("active");
		   item.setAttribute("data-active", "true");
	    }

			
	    fetch(this.url+"?id="+id+"&lang="+lang, {
		method: 'GET',
		}).then(res => res.text())
		.then(data => {

			let tabsContent = this.tabsContent;
			setTimeout(function () {
				// Update content in container
				tabsContent.innerHTML = '';
				tabsContent.insertAdjacentHTML('beforeend', data);

				// init section slider
				const section_slider = $("[data-item='section-slider']");
				
				if (section_slider.length > 0) {
				$("[data-item='section-slider']").slick({
					dots: false,
					arrows: true,
					infinite: true,
					slidesToShow: 4,
					slidesToScroll: 1,
					responsive: [
						{
						breakpoint: 991,
						settings: {
							slidesToShow: 3,
						}
						},
						{
						breakpoint: 767,
						settings: {
							slidesToShow: 2,
						}
						},
						{
						breakpoint: 467,
						settings: {
							slidesToShow: 1,
						}
						}
					]
					});
				}
			
				tabsContent.classList.remove('hide');	
			}, 500);
		})
	}
 }
 
 window.addEventListener('load', () => {
	// Get all tabs list that need to use this functionality
	const tabsWrapper = document.querySelectorAll(`[data-tabs="wrapper"]`);
	if (tabsWrapper.length > 0) {
		tabsWrapper.forEach(tabs => {
		   // Find all tabs elements
		   const tabsList = tabs.querySelectorAll(`[data-tabs="items"]`);
		   
		   tabsList.forEach(element => {
			  // Init functionality for every element
			  new Tabs(element);
		   })
	    })
	}
 })